/**
 * 字典
 * Created by slipkinem on 2018/8/22 at 下午2:48.
 */

export interface OptionItem {
  id?: number;
  name: string;
  code: number | string;
}

// 从字典列表中根据指定的内容返回命中对象中指定的属性
export const getOptionNameByCode = (
  // 匹配是否命中的内容
  matched: number | string | null,
  // 目标对象列表
  targets: OptionItem[]
): string => {
  let optionName = "";

  targets.forEach((item) => {
    if (typeof item.code !== "undefined" && item.code === matched) {
      optionName = item.name;
    }
  });

  return optionName;
};
